import AuthContext from "../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { postUpdatedAccountInfo, addNewEmployee } from "../helpers/tableauAccountHelpers";
import { useContext, useEffect, useState } from "react";
import { getUserRoleTypes, refreshDirectReports, getEntities, getUser } from "../helpers/tableauUserHelpers";
import {BeatLoader} from "react-spinners";

//import lockImg from "../content/img/lock.png";
//import unLockImg from "../content/img/unlock.png";

import { formatPhone } from "../scripts/ccbh";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";

import '../content/ccbh.ui.css';
import 'react-tabs/style/react-tabs.css';
import '../content/ccbh-tableau-portal_2.0.css';
import './addEditUserModal.css';

import { getManagers, getManagersOptions, getManagersOptionsNew } from "../helpers/getEntities";
import { addStat } from "../helpers/statHelpers";
import { BsFillMotherboardFill } from "react-icons/bs";


const AddEditUserModal = ({closeModal, user, selectedEmployee, refreshDirectReportList, modalMode = 'Edit'}) =>{
    let navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const spinnerCSS = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        zAxis: 999,
     };

    const [selectUserWebuserId, setSelectedUserWebuserId] = useState(selectedEmployee.webuserId);
    const [selectedUserFirstName, setUserFirstName] = useState(selectedEmployee.firstName);
    const [selectedUserLastName, setUserLastName] = useState(selectedEmployee.lastName);
    const [selectedUserEmail, setUserEmail] = useState(selectedEmployee.email);
    const [selectedUserPhone, setUserPhone] = useState(selectedEmployee.phoneNumber);
    const [selectUserLastLogin, setSelectedUserLastLogin] = useState(null);
    const [selectUserRole, setSelectedUserRole] = useState(selectedEmployee.title);
    
    //const [selectedManager, setSelectedManager] = useState(user);
    
    const fetchManagers = async() => {
        return await getManagers();
        //setAllManagers(getManagers());
    };

    const [allManagers, setManagers] = useState([]);
    const [managerOptions, setManagerOptions] = useState([]);
    const [managerOptionsNew, setManagerOptionsNew] = useState([]);

    const [selectedManager, setManagerSelect] = useState([]);
    const setManagerInitial = () => {
        if (modalMode == 'Edit'){
            return selectedEmployee.managerId;
        }else if(modalMode == 'Add' && user.isCzar){
            return '';
        }else{
            return user.webuserId;
        }
    };
    const [selectedManagerNew, setManagerSelectNew] = useState(setManagerInitial);

    
    const [state, setState] = useState("");
    const [directReportList, setDirectReportList] = useState(user.directReportEmployees);
    const [mode, setMode] = useState(modalMode);
    
    const fetchEntity = async() => {
        let enabled = 'Y';
        if(user.webuserId === 'ccbhtabmanager'){
            enabled = 'A'
        }
        return await getEntities(enabled);
    };

    const setInitialEntity = () => {
        if (modalMode == 'Edit' && user.isCzar){
            // if editing an existing user return their entity id, name
            return {value: selectedEmployee.tableauEntities[0].id, label:selectedEmployee.tableauEntities[0].name};
        }else if(modalMode == 'Add' && user.isCzar){
            ///if adding user as Czar return select one
            return {value:'', label: ''};
        } else{
            // if adding user as manager return their entity id, name
            return {value: user.tableauEntities[0].id, label:user.tableauEntities[0].name};
        }
    }
    const [selectedEntity, setSelectedEntity] = useState(setInitialEntity);
    const [entities, setEntities] = useState(async() => await fetchEntity());
    const [entitiesOptions, setEntitiesOptions] = useState([]);

    const isManagerReadOnly = () => {
        if((user.webuserId === 'ccbhtabmanager') || (mode === 'Edit')){
            return '';
        }
        return 'disabled';
    };

    const isEntityEnabled = (webuser) => {
        if((webuser != undefined) && (webuser.tableauEntities[0].id !== "0") )  {
            return 'disabled';
        }
        return '';
    }
    const [entitySelectEnable, setEntitySelect] = useState(() => isEntityEnabled(user));

    const [managerReadOnly, setManagerReadOnly] = useState(() => isManagerReadOnly());

    const isUsernameDisabled = () => {
        if(selectUserWebuserId === '' || selectUserWebuserId === undefined){
            return 'disabled';
        }else{
            return '';
        }
    }
    const [usernameDisabled, setUsernameDisabled] = useState(() => isUsernameDisabled());

    const [saveButtonDisabled, setSaveButtonDisabled] = useState("disabled");
    const [userRoles, setUserRoles] = useState('');
    const [roleOptions, setRoleOptions] = useState('');

    const fetchUserRoles = async() => {
        return await getUserRoleTypes();
    };

    const roleListOption = (value, name) =>{
        var selected='';
        if(selectedEmployee.title === name){
            selected = "selected";
        }
        return (
            <option key={value} value={value} >{name}</option>
        )
    };

    const handleFirstNameChange = event =>{
        setUserFirstName(event.target.value);
        enableUpdateAccount();
    };
    
    const handleLastNameChange = event => {
        setUserLastName(event.target.value);
        enableUpdateAccount();
    };
    
    const handleEmailChange = event => {
        setUserEmail(event.target.value);
        enableUpdateAccount();
    };
    
    const handlePhoneChange = event => {
        setUserPhone(event.target.value);
        enableUpdateAccount();
        phoneFormat();
    };
    const handleUserRole = event =>{
        setSelectedUserRole(event.target.value);
        enableUpdateAccount();
    };

    const handleManagerChange = (v) =>{
        setManagerSelect({value: v, options: managerOptions});

        if(v.value !== user.webuserId){
            let sm = user.directReportEmployees.find((man) => {
                if(man.webuserId === v.value){
                    return man;
                }
            });
            //setSelectedManager(sm);
            setEntitySelect(isEntityEnabled(sm));
            if(selectedEntity === null || selectedEntity === "" || selectedEntity?.value.value !== sm.tableauEntities[0].id){
                /*const results = []
                eo.forEach((val) => {
                    results.push({
                        value: val.id,
                        label: val.name
                    });
                }); */
                const se = {value: sm.tableauEntities[0].id, label: sm.tableauEntities[0].name}
                setSelectedEntity({value: se, options: entities});
            }
        }
        enableUpdateAccount();
    };

    const hangleManagerChange = event => {
        if(event.target.value !== user.webuserId){
            let sm = user.directReportEmployees.find((man) => {
                if(man.webuserId === event.target.value){
                    return man;
                }
            });
            //setSelectedManager(sm);
            //setEntitySelect(isEntityEnabled(sm));
            setManagerSelectNew(sm.webuserId);
            
            if(sm.tableauEntities[0].id !== selectedEntity.value){
                setSelectedEntity({value: sm.tableauEntities[0].id, options: entities});
            }
        }
        enableUpdateAccount();
    };

    const filterAllManagers = (entityId, filteredManagers) => {
        //let filteredManagers = []
        allManagers.find((man) => {
            if(entityId === man.entityId){
                filteredManagers.push(man);
            }
        });
    };

    const handleEntityChange = async(event) =>{
        setManagerSelect([]);
        setManagerOptionsNew(null);
        //setSelectedManager(null);
        setSelectedEntity({value: event, options: entities});
        
        let filteredManagers = []
        filterAllManagers(event.value, filteredManagers);
       
        setManagerOptionsNew(filteredManagers.map((m) => managerList(m.webuserId, m.name)));
       
        const mo = await getManagersOptions(event.value);
        const results = []
        mo.forEach((val) => {
            results.push({
                value: val.value,
                label: val.label
            });
        });
        setManagerOptions([...results]);
    };

    const handleEntityOptionsChange = async(event) =>{
        setManagerSelectNew([]);
        setManagerOptionsNew(null);
        
        let filteredManagers = []
        filterAllManagers(event.target.value, filteredManagers);
        setManagerOptionsNew(filteredManagers.map((m) => managerList(m.webuserId, m.name)));

        setSelectedEntity(event.target.value);
        setManagerSelectNew(selectedEmployee.managerId);
        
        //new
        const mon = await getManagersOptionsNew(event.target.value);
        const resltn = []
        setManagerOptionsNew(mon.map((m) => managerList(m.webuserId, m.name)));
        
        // old
        const mo = await getManagersOptions(event.target.value);
        const results = []
        mo.forEach((val) => {
            results.push({
                value: val.value,
                label: val.label
            });
        });
        setManagerOptions([...results]);
    };

    function phoneFormat(){
        formatPhone(document.getElementById("user-phone"));
    };

    const validData = (data) => {
        if (data !=='' && data !== undefined && data !== null){
            return true;
        }
        return false;
    };

    function enableUpdateAccount() {
        if( validData(selectedUserFirstName) && validData(selectedUserLastName) && validData(selectedUserEmail) && validData(selectedUserPhone) && validData(setSelectedUserRole)){
            setSaveButtonDisabled("");
        }else{
            setSaveButtonDisabled("disabled");
        }
    };

    const updateAccountInfo = async event => {
        var response;
        var dlgSuccessMessage;
        var dlgErrorMessage;
        var dlgUsername;
        if(mode === 'Edit'){
            console.log('update account info', user.webuserId);
            dlgSuccessMessage = "Account Information Updated";
            dlgErrorMessage = "Problem Updating Account Information, try again!";
            dlgUsername = document.getElementById('user-username').defaultValue;

            response = await postUpdatedAccountInfo(document.getElementById('user-username').defaultValue,
                                selectedUserFirstName, 
                                selectedUserLastName,
                                selectedUserEmail,
                                selectedUserPhone,
                                selectUserRole,
                                selectedManagerNew,
                                user.webuserId);
        
            console.log('update 2: ', response);
        }else if(mode === 'Add'){
            console.log('Add New User Account');
            response = await addNewEmployee(
                                selectedUserFirstName, 
                                selectedUserLastName,
                                selectedUserEmail,
                                selectedUserPhone,
                                selectUserRole,
                                selectedManagerNew);

            dlgSuccessMessage = "New User Successfully Created<br />Username: " + response.value.username;
            dlgErrorMessage = "Problem Creating New User Account, try again!";
            dlgUsername = response.value.username;
        }
    
        if(response === 1 || response.value.errorCode === 0){
            setSaveButtonDisabled(true);
            setDirectReportList(null);
            setDirectReportList(refreshDirectReports(user.webuserId));
            
            ccbhmessagebox({
                message: dlgSuccessMessage,
                title: "User Account Information",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok': function () {
                            addStat(user.webuserId, modalMode + ' User', 'Saved: ' + dlgUsername);
                            removeMsg();
                            refreshDirectReportList();
                    }
                }
            });
        }else{
            ccbhmessagebox({
                message: dlgErrorMessage,
                title: "User Account Information",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok': function () {
                            removeMsg();
                    }
                }
            });
        }
    };

    function validateUserInfo() {
        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

        var errorText = ''
        if(document.getElementById('user-firstname').value === ''){
             errorText = "Must Enter User First Name <br />";
        }
        if(document.getElementById('user-lastname').value === ''){
                    errorText += "Must Enter User Last Name <br />";
        }
        if((document.getElementById('email').value === '') || (!document.getElementById('email').value.match(isValidEmail))){
                    errorText += "Must Enter A Valid User Email Address <br />";
        }
        if(document.getElementById('user-role').value === ''){
                    errorText += "Must Select A User Role <br />";
        }

        var phone = document.getElementById('user-phone').value;
        if(phone !== ''){
            var phoneNum = phone.replace(/[^\d]/g, '');
            if(!(phoneNum.length === 10)) {  
                errorText += "Phone Number Is Not a Valid Format";  
            }
        }

        if(errorText !== ''){
            document.getElementById('email-error').innerHTML = errorText;
        }else{
            updateAccountInfo();
            closeModal();
            refreshDirectReportList();
            
        }
    };

    const cancelModal = () => {
        closeModal('cancel');
        let addEditusername = '';
        if (selectUserWebuserId !== undefined){
            addEditusername = selectUserWebuserId;
        }
        addStat(user.webuserId, modalMode + ' User', 'Canceled: ' + addEditusername);
    };
    
    
    const entityList = (value, name) =>{
        let selected='';
        if(selectedEntity !== null && selectedEntity.id === value){
            selected = 'selected';
        }
        return (
            <option value={value} >{name}</option>
        );
    };

    const fetchUser = async(username) => {
        return await getUser(username);
    };

    const setManager = (checkId) => {
        let manager = fetchUser(checkId);
        return manager;
    };

    const managerList = (value, name, entityId) => {
        let selected='';
        /*
        if((selectedEntity != null && entityId != undefined) && selectedEntity.id != entityId && modalMode === 'Edit'){
            return
        }
        */
        if((selectedEmployee !== null && selectedEmployee.managerId === value) || (modalMode === 'Add' && user.webuserId === value) ){
            selected = 'selected';
        }
        //  if entityId of manager is not equal to entityId of logged in user disable selecting this manager option
        // should only be for ccbhtabmanager
        let disabled = '';
        let opt = <option value={value}>{name}</option>;

        if (user.tableauEntities[0].id !== entityId){
            disabled = 'disabled';
            opt = <option value={value} disabled>{name}</option>;
        }

        return (
            opt
            //<option value={value} {disabled}>{name}</option>
        );
    };

    const setSelectOne = (optionArray) => {
        if(optionArray.some(a => a.props.selected == "selected")){
            optionArray.unshift(<option value="-1">-- Select One --</option>);
        }else{
            optionArray.unshift(<option value="-1" selected="selected">-- Select One --</option>);
        }
        return optionArray;
    };

    useEffect(() => {
        async function fetchFilteredManagerOptions(entityId){
            const mon = await getManagersOptionsNew(entityId);
            setManagerOptionsNew(mon.map((m) => managerList(m.webuserId, m.name, m.entityId)));
        };
        
        async function fetchManagerOptionsData(){
            const mo = await getManagersOptions();
            const results = []
            mo.forEach((val) => {
                results.push({
                    value: val.value,
                    label: val.label
                });
            });
            setManagerOptions([...results]);
        };
        let sm = setInitialEntity();
        setSelectedEntity(sm);
        
        fetchManagerOptionsData();

        if(selectedManagerNew === ''){
            fetchManagers().then((managers) => {
                setManagerOptionsNew(managers.map((m) => managerList(m.webuserId, m.name)));
            });
        }else{
            fetchFilteredManagerOptions(selectedEntity.value);
        }


        if(selectUserWebuserId === '' || selectUserWebuserId === undefined || selectUserWebuserId === null){
            setMode('Add');
        }else{
            addStat(user.webuserId, modalMode + ' User',selectUserWebuserId);
        }

        fetchUserRoles().then((roles) =>{
            setUserRoles(roles);
            setRoleOptions(roles.map((r) => roleListOption(r.role_id, r.name)));
        });

        if(selectedEmployee.lastLoginDate !== null && selectedEmployee.lastLoginDate !== undefined){
            setSelectedUserLastLogin(format(parseISO(selectedEmployee.lastLoginDate), "MMM d, yyyy"));
        }   

        async function fetchEntityOptionsData(){
            const eo = await fetchEntity();
            const results = []
            eo.forEach((val) => {
                results.push({
                    value: val.id,
                    label: val.name
                });
            });
            setEntities(results);
        }
        fetchEntityOptionsData();
        
        fetchEntity().then((et) =>{
            setEntitiesOptions(et.map((e) => entityList(e.id, e.name)));
        });

        fetchManagers().then((al) => {
            setManager(al);
        });

        if(user.isCzar && (allManagers != null || allManagers != undefined)){
            let filteredManagers = []
            // filterAllManagers(selectedEntity.id, filteredManagers);
            // setManagerOptions(filteredManagers.map((m) => managerList(m.webuserId, m.name)));
        }
        setLoading(false);
    }, [2]);


    return(
        <>
        <div className="modal-container-userEdit">
            <div className="modal-userEdit">
            <div id="">
                <h6>{selectedUserFirstName} {selectedUserLastName} Account Information</h6>
            </div>
            <div id="login_loader">
                <BeatLoader 
                    color="#762d6a"
                    loading={loading}
                    size={25}
                    aria-label="Logging In"
                    data-testid="loader"
                    cssOverride={spinnerCSS}
                />
            </div>
            <div className="account-info-row">
                <input className="settings-text-input css-13cymwt-control" type="text" id="user-username" name="user-username" defaultValue={selectUserWebuserId} disabled={usernameDisabled} />
                <label className="settings-label">Username</label>
            </div>

            <div className="account-info-row">
                    <input className="settings-text-input css-13cymwt-control" type="text" id="user-firstname" name="user-firstname" defaultValue={selectedUserFirstName} onChange={handleFirstNameChange}  required />
                    <label className="settings-label">First Name</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="text" id="user-lastname" name="user-lastname" defaultValue={selectedUserLastName} onChange={handleLastNameChange}  required />
                    <label className="settings-label" id="user-lastname">Last Name</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="email" id="email" name="email" title="Enter a valid email address" x-moz-errormessage="Please enter a valid email address" defaultValue={selectedUserEmail} onChange={handleEmailChange}  required />
                    <label className="settings-label">Email</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="tel" id="user-phone" name="phone" title="Format:(123)446-7890" x-moz-errormessage="Format:(123)446-7890" defaultValue={selectedUserPhone} onChange={handlePhoneChange}  required />
                    <label className="settings-label" id="user-phone">Phone Number</label>
                                                                                
                    <span id="email-error-span"><label className="warning" id="email-error"></label></span>
                    <span id="phone-error-span"><label className="warning" id="phone-error"></label></span>
            </div>

            <div className="account-info-row">
                <select className="userManager css-13cymwt-control" id="manager-id" name="manager-id" onChange={hangleManagerChange} disabled={managerReadOnly} value={selectedManagerNew} defaultValue={selectedManagerNew}>
                    <option value="">-- SELECT ONE --</option>
                    {managerOptionsNew}
                </select>
                <label id="manager-label">Supervisor Name</label>
                <br /><br />

                <select className="managerEntity css-13cymwt-control" name="manager-entity" id="manager-entity" onChange={handleEntityOptionsChange} value={selectedEntity.value} defaultValue={selectedEntity.value} disabled={entitySelectEnable}>
                    <option value="">-- SELECT ONE --</option>
                    {entitiesOptions}
                </select>
                <label id="entity-label">Entity Name</label>
                <br />
                <br />

                <select className="css-13cymwt-control"  name="userRole" id="user-role" onChange={handleUserRole} defaultValue={selectUserRole} value={selectUserRole} >
                    <option value="">-- SELECT ONE --</option>
                    {roleOptions}
                </select>
                <label className="settings-label">User Role</label>
                <br />

                <input className="settings-text-input css-13cymwt-control" type="text" id="user-lastlogin" title="user last login time" disabled defaultValue={selectUserLastLogin} />
                <label className="settings-label" id="last-login">Last Login Date</label>
                <br />
            </div>

            <div className="shadow-talk" id="edit-account-info">
                <div id="settings-button-row">
                    <input type="button" id="user_update_account_info" name="user_update_account_info" onClick={validateUserInfo}  value="Save" disabled={saveButtonDisabled} /> 
                    <input type="button" id="close-modal" name="close_user_update_modal" onClick={cancelModal} value="Cancel" />
                </div>
            </div> {/* <!-- setting form wrapper --> */}

        </div>
        </div>    
        </>
    );
};

export default AddEditUserModal;